import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f12af010: FaireBrandEntity = {
  token: "b_f12af010",
  type: "brand",
  name: "Banquet Workshop",
  avatarUrl:
    "https://cdn.faire.com/fastly/97cc6a2a55ad9068148722b2b37e0ceed781df31daff47ad96e511e80861fd2c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/34c753b7e7f1edae7938048c940b2e025d00cc714ce9f8b5afe010578734a5d0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/97cc6a2a55ad9068148722b2b37e0ceed781df31daff47ad96e511e80861fd2c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/34c753b7e7f1edae7938048c940b2e025d00cc714ce9f8b5afe010578734a5d0.jpeg",
  location: "Vancouver, BC, CAN",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 73,
  isInsider: false,
  description:
    "Banquet Atelier & Workshop Ltd. is a Vancouver-based studio creating beautiful things for families everywhere. We offer art prints, stationery, textiles & more, designed and produced in Canada with an eye to affordability, sustainability and a whole lotta magic.\n\nWe have licensed our work and collaborated with the Metropolitan Museum of Art, New York, Terrain, Anthropologie, Trader Joe and Land of Nod and others to create exclusive product and designs. \n\nCurrent inspirations include the smell of a Pacific Northwest forest baking on hot summer day, neon overprints, knitting oversized multi-coloured cardigans, salad picked from the garden, Lucia Berlin and James Baldwin, swimming in the ocean and kids creative set-ups made up of anything they can find. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:14.328Z",
    importedBy: "entity-db-cli",
  },
};
